import { render, staticRenderFns } from "./ReferralsViewDetails.vue?vue&type=template&id=20160b3c&scoped=true"
import script from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
export * from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralsViewDetails.vue?vue&type=style&index=0&id=20160b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20160b3c",
  null
  
)

export default component.exports